import ExpansionPanel from './ExpansionPanel';

export default ExpansionPanel;
